import { FC } from 'react';
import { TitleProps } from './types';

const PrimaryTitle: FC<TitleProps> = (props) => {
	return <h1 className={`pop-font-bold pop-text-xl pop-text-popsizePrimary90 pop-mb-10 ${props.className}`}>{props.children}</h1>;
};

export default PrimaryTitle;
